import { Component, OnInit, Input, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';
import { BookingService } from '../../services/booking.service';
import { TinyDatePicker, DateRangePicker } from '../../../../vendor-modified/tiny-date-picker/date-range-picker';
import { DatepickerService } from 'app/services/datepicker.service';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html'
})
export class DatePickerComponent implements OnInit {
  applyLabel = "";
  datepicker: any;
  tzOffset: number = ((new Date()).getTimezoneOffset()*60*1000); // Timezone offset to tackle JS date object for negative timezones when UTC is a day ahead.
  date: Date = new Date((new Date()).getTime() + (this.tzOffset > 0 ? this.tzOffset : 0));
  endDate: Date = this.addDays(this.date, 1);
  dateText = "";
  rootEle: any;
  maxAllowedEndDate: Date;
  previousTimeout: any;
  isOpen = false;
  prevBtn: any;
  fromDate = this.date.getFullYear() + '-' + this.date.getMonth() + '-' + this.date.getDate();
  toDate = this.endDate.getFullYear() + '-' + this.endDate.getMonth() + '-' + this.endDate.getDate();
  endCalFirstDate: any;
  closeListner: any;

  @Input('range') isDateRange: boolean;
  @ViewChild('date', { static: false }) dateEle: ElementRef;
  @Output() dataChanged: any = new EventEmitter<{}>();

  constructor(private bookingService: BookingService, private datepickerService: DatepickerService) { }

  ngOnInit(): void {
    /** For Angular SSR bypass complete JS to resolve window and document related issues  */
    if (typeof window == 'undefined' || typeof document == 'undefined')
      return;
  }

  ngAfterViewInit(): void {
    this.maxAllowedEndDate = this.addDays(new Date(), 395);
    this.rootEle = this.dateEle.nativeElement.parentElement;
    this.dateText = this.displayDate(this.date) + ' - ' + this.displayDate(this.endDate);

    const savedDateData = this.bookingService.getSearchData('date');
    if (savedDateData) {
      this.date = new Date(savedDateData.date);
      this.endDate = new Date(savedDateData.endDate);
    }
    const currentUrl = window.location.href.toLowerCase();
    const isResetDataReqd = currentUrl.indexOf('fromdate') != -1 || currentUrl.indexOf('?hotel') != -1;
    if (document.querySelector("[modify-date]") || isResetDataReqd) {
      const bookingWidgetData = window['Scandic'].bookingWidgetData;
      if (bookingWidgetData && bookingWidgetData.fromDate && bookingWidgetData.toDate) {
        this.date = new Date(bookingWidgetData.fromDate);
        this.endDate = new Date(bookingWidgetData.toDate);

        // Timezone offset to tackle JS date object for negative timezones when UTC is a day ahead.
        this.date.setDate(bookingWidgetData.fromDate.substr(bookingWidgetData.fromDate.lastIndexOf("-")+1));
        this.endDate.setDate(bookingWidgetData.toDate.substr(bookingWidgetData.toDate.lastIndexOf("-")+1));
      }
    }
    if (this.isDateRange) {
      this.updateDatePicker();
      this.udpateDate();
    } else {
      this.datepicker = TinyDatePicker('.date-picker__calendar');
      this.datepicker.state.selectedDate = this.date;
      this.dateText = this.displayDate(this.date);
    }

    this.applyLabel = this.datepickerService.translations[this.bookingService.language]['apply'];
  }

  updateDatePicker(): void {
    let minStartDate = new Date((new Date()).getTime() + (this.tzOffset > 0 ? this.tzOffset : 0));
    let maxEndDate = this.addDays(minStartDate, 395);
    if (this.date && !this.endDate) {
      minStartDate = this.dateInRange(this.date, "start") ? this.removeDays(this.date, 99) : minStartDate;
      maxEndDate = this.dateInRange(this.date) ? this.addDays(this.date, 99) : maxEndDate;
    }
    const self = this;
    let highlightedDate = this.endDate || this.date;
    if ((this.endCalFirstDate || this.date.getMonth() != this.endDate.getMonth()) && window.innerWidth >= 768) {
      const d = new Date(highlightedDate);
      d.setMonth(highlightedDate.getMonth()-1);
      if (d.getDate() != highlightedDate.getDate()) {
        d.setDate(-1);
      }
      if (!this.endCalFirstDate) {
        this.endCalFirstDate = this.endDate.getTime();
      }
      highlightedDate = this.endCalFirstDate <= highlightedDate.getTime() ? d : highlightedDate;
    }

    this.datepicker = DateRangePicker('.date-picker__calendar', {
      startOpts: {
        lang: this.datepickerService.translations[this.bookingService.language],
        max: maxEndDate,
        min: minStartDate,
        hilightedDate: highlightedDate,
        dayOffset: 1,
      },
      endOpts: {
        lang: this.datepickerService.translations[this.bookingService.language],
        max: maxEndDate,
        min: minStartDate,
        dayOffset: 1,
      }
    });
    this.datepicker.setState({
      start: this.date,
      end: this.endDate
    });
    this.datepicker.on('statechange', (_, picker) => {
      self.date = picker.state.start;
      if (picker.state.end && picker.state.start.toDateString() != picker.state.end.toDateString())
          self.endDate = picker.state.end
      else
          self.endDate = null;

      setTimeout(function () {
        this.endCalFirstDate = document.querySelectorAll(".dr-cal-end .dp-day:not(.dp-edge-day)")[0];
        this.endCalFirstDate = this.endCalFirstDate.getAttribute("data-date");
        self.updateDatePicker();
        const selectedBtns = <any>document.querySelectorAll(".dr-selected:not(.dp-edge-day)");
        selectedBtns[selectedBtns.length - 1].focus();
      }.bind(self), 10);
    });
  }

  udpateDate(): void {
    if (!this.date || !this.endDate) {
      return;
    }
    if (this.date.toDateString() === this.endDate.toDateString()) {
      this.endDate = null;
      this.datepicker.setState({
        start: this.date,
        end: this.endDate
      });
      return;
    }
    this.fromDate = this.getformattedDate(this.date);
    this.toDate = this.getformattedDate(this.endDate);
    this.dateText = this.displayDate(this.date) + ' - ' + this.displayDate(this.endDate);
  }

  getformattedDate(date: Date): string {
    return date.getFullYear() + '-' + ("0" + (date.getMonth()+1)).slice(-2) + '-' + date.getDate();
  }

  toggleDatePicker(state?: string, e?: any): void {
    if (!state) {
      state = this.isOpen ? "close" : "open";
    }
    if (state === 'open') {
      this.isOpen = true;
      this.addCloseListners();
    } else if (state === 'close') {
      this.isOpen = false;
      this.removeCloseListners();
      if (e && e.type == "click") {
        this.closeDP(true);
      }
    }
  }

  _focusOutListner(e: any): void {
    if (e)
      e.preventDefault();
    if (!this.rootEle.contains(e.target))
      this.closeDP();
  };

  addCloseListners(): void {
    this.closeListner = this._focusOutListner.bind(this);
    document.addEventListener("click", this.closeListner, false);
    document.addEventListener("keyup", this.closeListner, false);
    if (document.querySelector("main.l-section"))
      document.querySelector("main.l-section")["style"].overflow = "visible";
  }

  removeCloseListners(): void {
    document.removeEventListener("click", this.closeListner, false);
    document.removeEventListener("keyup", this.closeListner, false);
    if (document.querySelector("main.l-section"))
      document.querySelector("main.l-section").removeAttribute("style");
  }

  closeDP(noToggle?: boolean): void {
    this.endDate = this.endDate || this.addDays(this.date, 1);
    if (!noToggle) {
      this.toggleDatePicker("close");
    }
    this.datepicker.setState({
      start: this.date,
      end: this.endDate
    });
    if (this.getformattedDate(this.date) != this.fromDate || this.getformattedDate(this.endDate) != this.toDate) {
      this.dataChanged.emit();
    }
    this.udpateDate();
  }

  onEnter(e: KeyboardEvent): void {
    if (e.code && e.which == 13) {
      e.preventDefault();
      this.toggleDatePicker("open");
    }
  }

  public saveSearchData(): void {
    this.bookingService.saveSearchData({
      date: this.date,
      endDate: this.endDate,
    }, 'date');
  }

  /*
   * Date to be displayed to user in the datepicker field
   */
  displayDate(d: Date): string {
    return d.getDate() + ' ' + this.getMonthByLang(d.getMonth());
  }

  getMonthByLang(month: number): string {
    return this.datepickerService.translations[this.bookingService.language]['monthsShort'][month];
  }

  addDays(date: Date, days: number): Date {
    return new Date(date.getTime() + (24*60*60*1000 * days) /* +n days*/);
  }

  removeDays(date: Date, days: number): Date {
    return new Date(date.getTime() - (24*60*60*1000 * days) /* -n days*/);
  }

  dateInRange(date: Date, state?: string): boolean {
    const d = new Date();
    d.setHours(0); d.setMinutes(0); d.setSeconds(0);
    if (state && state == "start")
      return this.removeDays(date, 99).getTime() >= d.getTime();
    else
      return this.addDays(date, 99).getTime() <= this.maxAllowedEndDate.getTime();
  }
}
